export const AlterationTableHeaders=[
    {
        Header:'Order Number',
        accessor:'orderNumber'
    },
    
    {
        Header:'Customer Name',
        accessor:'customerName'
    },
    {
        Header:'Due Date',
        accessor:'dueDate'
    },
    {
        Header:'Phone',
        accessor:'phone'
    },
   
    {
        Header:'Description',
        accessor:'description'
    },
    {
        Header:'Num of Items',
        accessor:'numOfItems'
    }
]
